import { render, staticRenderFns } from "./UgiInputAddress.vue?vue&type=template&id=559b3d20&"
import script from "./UgiInputAddress.vue?vue&type=script&lang=js&"
export * from "./UgiInputAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports